import { createSelector } from 'reselect';

import {
  // Frame
  hasUserSelector,
  // Navigation
  helpFooterSelector,
  aboutFooterSelector,
  careersFooterSelector,
  investorRelationsFooterSelector,
  pressFooterSelector,
  xingCommunityFooterSelector,
  newWorkExperienceFooterSelector,
  blogFooterSelector,
  devBlogFooterSelector,
  developersFooterSelector,
  peopleDirectoryFooterSelector,
  // Props
  localeSelector,
} from '../../selectors';
import { localizedLink } from '../../selectors/utils';

const aboutLinksInputSelectors = [
  hasUserSelector,
  localeSelector,
  helpFooterSelector,
  aboutFooterSelector,
  careersFooterSelector,
  investorRelationsFooterSelector,
  pressFooterSelector,
  xingCommunityFooterSelector,
  newWorkExperienceFooterSelector,
  blogFooterSelector,
  devBlogFooterSelector,
  developersFooterSelector,
  peopleDirectoryFooterSelector,
];
const aboutLinksTransform = (
  hasUser,
  locale,
  helpFooter,
  aboutFooter,
  careersFooter,
  investorRelationsFooter,
  pressFooter,
  xingCommunityFooter,
  newWorkExperienceFooter,
  blogFooter,
  devBlogFooter,
  developersFooter,
  peopleDirectoryFooter
) => {
  const isDeutsch = locale === 'de';
  return [
    helpFooter,
    aboutFooter,
    careersFooter,
    investorRelationsFooter,
    pressFooter,
    xingCommunityFooter,
    isDeutsch && newWorkExperienceFooter,
    blogFooter,
    devBlogFooter,
    developersFooter,
    !hasUser && peopleDirectoryFooter,
  ]
    .filter(Boolean)
    .map(localizedLink(locale));
};
export default createSelector(
  ...aboutLinksInputSelectors,
  aboutLinksTransform
);
